module.exports = __webpack_public_path__ + "img/Stara_login.dc6238c0.png";